/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatCardModule } from "@angular/material/card";
import { ButtonComponent } from "../button/button.component";
import { ScenarioLayer } from "../../models/http/what-if/scenario/scenario-layer.model";
import { roundValueUpTo } from "../../utils/utils";
import { MaxDecimalsPipe } from "../../pipes/max-decimals.pipe";

@Component({
	selector: "globalictcc-layer-configuration",
	standalone: true,
	imports: [MatCardModule, ButtonComponent, MaxDecimalsPipe],
	templateUrl: "./layer-configuration.component.html",
	styleUrl: "./layer-configuration.component.scss"
})
export class LayerConfigurationComponent {
	@Input() public layerConfigurationInput: ScenarioLayer;
	@Input() public isEditable: boolean = false;

	@Output() public handleEditLayer = new EventEmitter<ScenarioLayer>();

	public timeRanges: string[] = ["0:00-6:59", "7:00-12:59", "13:00-18:59", "19:00-23:59"];

	public getRoundedValueConfigInputPue() {
		return this.layerConfigurationInput.pue ?? 0;
	}
}
